import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M8.27 17.67c.323 2.486 1.888 4.428 3.932 4.621 1.996.19 3.85-1.344 4.67-3.633a6.97 6.97 0 0 1 1.907-2.835c1.409-1.272 2.416-3.274 2.636-5.602.396-4.187-1.912-7.83-5.156-8.137-1.49-.141-2.917.445-4.064 1.529"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M10.975 16.27c.12 1.04.923 1.826 1.828 1.77.927-.053 1.61-.975 1.52-2.055l-.014-.138a.734.734 0 0 1 .699-.848c.013.002.022-.002.036 0 1.818-.06 3.228-1.655 3.12-3.536-.112-1.945-1.76-3.438-3.632-3.295-.01 0-.014.003-.023.003-1.081.094-1.89.957-1.882 1.978.016 1.701 2.588 3.473 5.132-.082.76-1.064 1.205-2.308.564-3.457-.376-.68-1.032-1.195-2.166-1.017"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M6.175 7.859c.416.722.563 1.606.334 2.482a3.26 3.26 0 0 1-1.498 1.995M3.33 8.537a1.3 1.3 0 0 1 .131.996c-.09.35-.317.63-.603.8M8.717 6.142a6.58 6.58 0 0 1 .667 4.964 6.53 6.53 0 0 1-3 3.993"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const EarIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
